import { Controller, FieldValues } from 'react-hook-form';

import { GroupedSelectFormFieldProps } from './GroupedSelect.interface';
import {
  createChangeHandler,
  resolveSelectionMode,
} from './GroupedSelect.utils';
import { GroupedSelectField } from './GroupedSelectField';

/**
 * React Hook Form wrapper for `GroupedSelectField`.
 * Use with `control` and `name` instead of `value` / `onChange`.
 */
export function GroupedSelectFormField<
  FormPayload extends FieldValues = FieldValues,
>({
  control,
  name,
  rules,
  onChange,
  onSelectChange,
  selectionMode,
  groups,
  ...fieldProps
}: Readonly<GroupedSelectFormFieldProps<FormPayload>>) {
  const resolvedSelectionMode = resolveSelectionMode(groups, selectionMode);
  const handleChange = createChangeHandler(
    resolvedSelectionMode,
    onChange,
    onSelectChange,
  );

  return (
    <Controller
      rules={rules}
      control={control}
      name={name}
      render={({
        field: { onChange: onFieldChange, onBlur, value: fieldValue },
      }) => (
        <GroupedSelectField
          {...fieldProps}
          groups={groups}
          selectionMode={resolvedSelectionMode}
          name={name}
          value={fieldValue}
          onBlur={onBlur}
          onChange={(nextValue, meta) => {
            onFieldChange(nextValue);
            handleChange(nextValue, meta);
          }}
        />
      )}
    />
  );
}
